import { jsx as r } from "@emotion/react/jsx-runtime";
import m from "@mui/material/Button";
import { forwardRef as f } from "react";
const n = f((o, t) => /* @__PURE__ */ r(m, { ...o, ref: t }));
n.displayName = "Button";
export {
  n as B
};
